module.exports = __webpack_public_path__ + "img/RBA_MODE_15s.ba81fa8b.jpg";